module.exports = __webpack_public_path__ + "img/effect-chain.3cb65610.svg";